
/**
 * Created by nijin on 6/6/17.
 */
import {Component, ViewChild, Output, EventEmitter, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NotificationType} from '../../../core/notify';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {ApiKeyService} from '../../api-key.service';
@Component({
  selector: 'nuc-delete-key-confirmation',
  template: `
       <app-modal #popup>
  <div class="app-modal-header">
    <h3 class="modal-title red">Delete API Key?</h3>
  </div>
  <div class="app-modal-body">
   <p>All Apps/Things associated with this API key will be disconnected from the platform. This action can't be undone.</p>
    <p class="setActiveTime text-center">Please type <span class="red">"DELETE"</span> to proceed</p>
    <div class="enterDelete">
      <input type="text" class="form-control" placeholder="" id="del-text" #deleteText 
      (keyup)="setButtonDisabled(deleteText)">
    </div>
    <label class="info"></label>
  </div>
  <div class="app-modal-footer">
    <div class="btn-group-1 text-center">
      <button class="btn btn-secondary" (click)="close()" id="delete-cancel" [disabled]="isLoading">
        {{'COMMON.CANCEL' | translate}}</button>
      <button class="btn btn-secondary btn-red"  [disabled]="isDisabled || isLoading" 
      id="delete" (click)="deleteKeys(deleteText)">
       <span *ngIf="isLoading"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> </span>
       {{(isLoading ? 'COMMON.DELETING':'COMMON.DELETE') | translate}}
        </button>
    </div>
  </div>

</app-modal>
 `,
  styleUrls: ['./popup.scss']

})
export class DeleteKeyConfirmationComponent implements OnInit {

   isSubmitted = false;
   isDisabled = true;
   isLoading = false;
   form: FormGroup;
    delete = 'delete';

  @ViewChild ('popup') popup;
  @ViewChild ('deleteText') deleteText;
  @Output() onAccept: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onReject: EventEmitter<number> = new EventEmitter<number>();

  constructor(private apikeyService: ApiKeyService,
              private notifier: NotificationBarService) {

  }

  ngOnInit() {

  }


  open() {
    this.popup.open();
  }

  close() {
    this.deleteText.nativeElement.value = '';
    this.isDisabled = true;
    this.popup.hide();
  }

  setButtonDisabled(deleteText) {
     this.isDisabled = deleteText.value.toLowerCase() !== this.delete;
  }

  deleteKeys(deleteText) {
    if (deleteText.value.toLowerCase() === this.delete) {
      this.isLoading = true;
      this.apikeyService.deleteAllApiKeys()
        .subscribe(response => {
          this.isLoading = false;
          this.notifier.create({type: NotificationType.Success, message: response.status.message});
          this.close();
          this.onAccept.emit(true);
        }, response => {
          this.notifier.create({type: NotificationType.Error, message: response.status.message});
          this.isLoading = false;
        });

    } else {
      deleteText.focus();
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/accounts/api-key/modal/delete.key.confirmation.ts